import { API_ENDPOINT, GetHeaders } from "./api";
import axios from "axios";

// método para fazer as notificações push
export const sendAceptedChangePlan = async (payload) => {
  try {
    const formData = new FormData();
    formData.append("type", payload.type);
    formData.append("payload", JSON.stringify(payload.payload));

    const { headers } = await GetHeaders(true);
    delete headers["Content-Type"]; // Deixe o navegador definir automaticamente

    const response = await fetch(`${API_ENDPOINT}/plan/sendAceptedChangePlan`, {
      method: "POST",
      body: formData,
      headers,
    });

    if (!response.ok) {
      const errorDetails = await response.json();
      throw new Error(
        `Erro ao salvar mensagem visualizada: ${response.status} - ${errorDetails.message}`
      );
    }

    return await response.json();
  } catch (err) {
    console.error("Erro no upload:", err);
    return {
      error: true,
      message: err.message || "Erro ao fazer upload do arquivo",
    };
  }
};

// método para fazer as notificações push
export const sendCancelChangePlan = async (payload) => {
  try {
    const formData = new FormData();
    formData.append("type", payload.type);
    formData.append("payload", JSON.stringify(payload.payload));

    const { headers } = await GetHeaders(true);
    delete headers["Content-Type"]; // Deixe o navegador definir automaticamente

    const response = await fetch(`${API_ENDPOINT}/plan/sendCancelChangePlan`, {
      method: "POST",
      body: formData,
      headers,
    });

    if (!response.ok) {
      const errorDetails = await response.json();
      throw new Error(
        `Erro ao salvar mensagem visualizada: ${response.status} - ${errorDetails.message}`
      );
    }

    return await response.json();
  } catch (err) {
    console.error("Erro no upload:", err);
    return {
      error: true,
      message: err.message || "Erro ao fazer upload do arquivo",
    };
  }
};
